import {ValidationResult} from '../interfaces/validation-result';
import {i18n, I18nUtil} from '../utils/i18n-util';

export let numberValidationRules = {
  i18n: i18n,
  validateIsNumber: function validateIsNumber(input: string, condition: any, context: any): ValidationResult {
    //console.log('validating isNumber');
    let result: ValidationResult = {
      isValid: this.i18n.isValidNumber(input)
    };
    if (result.isValid) {
      context.parsedNumber = this.i18n.deLocalizeNumber(input);
    } else {
      result.errorMessage = this.i18n.getText('cu|validation engine|Must be a number');
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateIsInteger: function validateIsInteger(input: string, condition: any, context: any): ValidationResult {
    // an integer string should have no chars that aren't numeric, except an optional negative sign at start
    //console.log('validating integer');

    //At this point we should already know that it is a number.
    //So then it's just a matter of whether it's a
    let result: ValidationResult = {
      isValid: input.indexOf(this.i18n.locale.NUMBER_FORMATS.DECIMAL_SEP) === -1
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|xx is not a valid integer.', { input: input} );
    }
    //console.log(`result: ${result.isValid}`);
    return result;
  },
  validateMaxNumberValue: function validateMaxNumberValue(input: string, maxValue: number, context: any): ValidationResult {
    //console.log('validating max number');
    let result: ValidationResult = {
      isValid: context.parsedNumber <= maxValue
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must be less than or equal to xx', {
        maxValue: this.i18n.localizeNumber(maxValue)
      });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMinNumberValue: function validateMinNumberValue(input: string, minValue: number, context: any): ValidationResult {
    //console.log('validating min number');
    let result: ValidationResult = {
      isValid: context.parsedNumber >= minValue
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must be greater than or equal to xx', {
        minValue: this.i18n.localizeNumber(minValue)
      });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMaxNumberLength: function validateMaxNumberLength(input: string, maxLength: number, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: input.length <= maxLength
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must have xx or less digits.', { maxLength: maxLength });
    }
    return result;
  },
  validateMinNumberLength: function validateMinNumberLength(input: string, minLength: number, context: any): ValidationResult {
    let result: ValidationResult = {
      isValid: input.length >= minLength
    };
    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must have xx or more digits.', { minLength: minLength });
    }
    return result;
  },
  validateMaxNumberValueExclusive: function validateMaxNumberValueExclusive(input: string, maxValue: number, context: any): ValidationResult {
    //console.log('validating min number');
    let result: ValidationResult = {
      isValid: context.parsedNumber < maxValue
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must be less than xx', {
        maxValue: this.i18n.localizeNumber(maxValue)
      });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMinNumberValueExclusive: function validateMinNumberValueExclusive(input: string, minValue: number, context: any): ValidationResult {
    //console.log('validating min number');
    let result: ValidationResult = {
      isValid: context.parsedNumber > minValue
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number must be greater than xx', {
        minValue: this.i18n.localizeNumber(minValue)
      });
    }
    //console.log('result: ' + result.isValid);
    return result;
  },
  validateMaxDecimals: function validateMaxDecimals(input: string, maxDecimals: number, context: any): ValidationResult {
    let countDecimals = function(value): number {
      if ((value % 1) === 0) {
        //integer
        return 0;
      }
      return value.toString().split('.')[1].length;
    };
    //console.log('validating max decimals');
    let result: ValidationResult = {
      isValid: countDecimals(context.parsedNumber) <= maxDecimals
    };

    if (!result.isValid) {
      result.errorMessage = this.i18n.getText('cu|validation engine|The number cannot have exceed xx decimal places.', { maxDecimals: maxDecimals });
    }
    //console.log('result: ' + result.isValid);
    return result;
  }
};
